var _defs, _path, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcultar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #223d51;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,10.74c1.51,0,2.74-1.22,2.74-2.74s-1.22-2.74-2.74-2.74-2.74,1.22-2.74,2.74,1.22,2.74,2.74,2.74Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.99,11.9l2.31-2.15c-.25-.53-.41-1.12-.41-1.75,0-2.27,1.84-4.1,4.1-4.1.73,0,1.41.21,2.01.54l1.98-1.84c-1.09-.59-2.41-.99-3.98-.99-4.23,0-6.65,2.9-7.71,4.63-.67,1.08-.67,2.45,0,3.53.38.62.95,1.4,1.7,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.01,4.1l-2.31,2.15c.25.53.41,1.12.41,1.75,0,2.27-1.84,4.1-4.1,4.1-.73,0-1.41-.21-2.01-.54l-1.98,1.84c1.09.59,2.41.99,3.98.99,4.24,0,6.65-2.9,7.71-4.63.67-1.08.67-2.45,0-3.53-.38-.62-.95-1.4-1.7-2.14Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.07,
    y: -2.03,
    width: 1.85,
    height: 20.06,
    rx: 0.93,
    ry: 0.93,
    transform: "translate(9.04 -4.77) rotate(47.04)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcultar);
export default __webpack_public_path__ + "static/media/ocultar.17086f6faf0b442aa42f0c08afeeb589.svg";
export { ForwardRef as ReactComponent };